var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3222_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8465 75.4H66.0465V39.0001V1.29998C66.0465 0.519977 65.5265 2.75403e-05 64.7465 2.75403e-05H12.7464C11.9664 2.75403e-05 11.4465 0.519977 11.4465 1.29998V75.4H3.64648C2.86648 75.4 2.34653 75.9199 2.34653 76.6999C2.34653 77.4799 2.86648 78 3.64648 78H12.7464H17.9464H59.5464H64.7464H73.8465C74.6265 78 75.1464 77.4801 75.1464 76.7001C75.1464 75.9201 74.6265 75.4 73.8465 75.4ZM16.6466 75.4001V5.20013H39.6923H60.8465V40.95V75.4L16.6466 75.4001ZM60.8465 75.4V40.95V6.50008C60.8465 5.72008 61.6265 5.20013 60.8465 5.20013H17.9465C17.1665 5.20013 16.6466 5.72008 16.6466 6.50008V75.4001H14.0465V2.60008H63.4466V75.4001L60.8465 75.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6037 37.7H49.4038C48.6238 37.7 48.1039 38.22 48.1039 39V40.2999H45.5038C44.7238 40.2999 44.2039 40.8199 44.2039 41.5999C44.2039 42.3799 44.7238 42.8998 45.5038 42.8998H48.1039V44.1998C48.1039 44.9798 48.6238 45.4997 49.4038 45.4997H54.6037C55.3837 45.4997 55.9037 44.9798 55.9037 44.1998V39C55.9037 38.22 55.3837 37.7 54.6037 37.7ZM53.3038 42.9H50.7037V40.2999H53.3038V42.9Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrived);
export default __webpack_public_path__ + "static/media/arrived.0628e72eb63f3843f133538e56940403.svg";
export { ForwardRef as ReactComponent };